import { MDBCol, MDBRow, } from "mdb-react-ui-kit";
import useResumeDocumentSection from "../../../hooks/useResumeDocumentSection";
import useResumeProperties from "../../../hooks/useResumeProperties";
import { formatPrenom } from "../../../utils/formatPrenom";
import { getInitials } from "../../../utils/getInitials";

export default function CssfUserInformationSection() {

    const { isAnonymous, isExperienceHidden } = useResumeProperties();
    const { user, experiences } = useResumeDocumentSection();

    return (
        <MDBRow style={ { marginTop: "20px" } }>
            <MDBCol md="3" className="header-cv" style={ {
                display: "flex",
                alignItems: "start",
                justifyContent: "end",
                color: "#009999"
            } }>
                <span className="fw-bold" style={ { textAlign: "end", width: "100%" } }>
                    INFORMATION PERSONNELLE
                </span>
            </MDBCol>
            <MDBCol md="9" className="text-start" style={ { display: "flex", alignItems: "flex-end" } }>
                <div
                    className="content-div"
                    style={ {
                        fontFamily: "Verdana, sans-serif"
                    } }
                >
                    <div className="h4" style={ { margin: 0 } }>
                        { isAnonymous ? (
                            <p className="h4">
                                <span className="fw-bold">
                                    { getInitials( user.firstName, false ) }
                                </span>
                                { ' ' }
                                <span className="fw-bold">
                                    { getInitials( user.lastName, true ) }
                                </span>
                            </p>
                        ) : (
                            <p className="h4" style={ { fontSize: "13px", fontFamily: "Verdana, sans-serif" } }>
                                <span>
                                     { formatPrenom( user?.firstName ) }
                                 </span>
                                { ' ' }
                                 <span>
                                     { user?.lastName?.toUpperCase() }
                                 </span>
                            </p>
                        ) }
                        { !isExperienceHidden && (
                            <p className="h4"
                               style={ { fontSize: "12px", fontFamily: "Verdana, sans-serif", marginTop: "10px" } }>
                                { experiences[ 0 ]?.employer }
                            </p>
                        ) }
                    </div>
                </div>
            </MDBCol>
        </MDBRow>
    );
}
